import React, { useEffect, useState } from 'react';
import { StyledImage, StyledWrapper } from './style';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';
import { navigateToFile } from '../../../utils/navigate';

const PeriodismoConfiable = () => {
  const [image, setImage] = useState();
  const [url, setUrl] = useState();

  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'periodismo') {
          setImage(el.icon);
          setUrl(el.url);
        }
        return image;
      });
    });
  }, []);

  const handleClick = () => {
    if (url) {
      navigateToFile(url);
    }
  };
  return (
    <StyledWrapper>
      <StyledImage src={image} onClick={handleClick} />
    </StyledWrapper>
  );
};

export default PeriodismoConfiable;
